import { Link } from 'react-router-dom';

export default function SobreNosotros() {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <div className="bg-slate-50 border-b border-gray-200 py-12">
        <div className="max-w-3xl mx-auto px-6">
          <Link to="/" className="inline-flex items-center gap-2 text-green-600 hover:text-green-700 text-sm font-semibold mb-6 cursor-pointer">
            <i className="ri-arrow-left-line" />
            Volver al inicio
          </Link>
          <h1 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-3">Sobre Nosotros</h1>
          <p className="text-gray-500">Conoce quiénes somos y por qué creamos RemesasVE</p>
        </div>
      </div>

      <div className="max-w-3xl mx-auto px-6 py-14">
        {/* Mission */}
        <div className="bg-green-50 border border-green-200 rounded-2xl p-7 mb-10">
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 flex items-center justify-center bg-green-600 rounded-xl flex-shrink-0">
              <i className="ri-heart-line text-white text-xl" />
            </div>
            <div>
              <h2 className="text-lg font-bold text-gray-900 mb-2">Nuestra Misión</h2>
              <p className="text-gray-600 text-sm leading-relaxed">
                Ayudar a los venezolanos en el exterior a encontrar la forma más económica y rápida de enviar dinero a sus familias en Venezuela. Comparamos los principales servicios de remesas para que tú ahorres tiempo y dinero.
              </p>
            </div>
          </div>
        </div>

        <div className="prose prose-gray max-w-none">
          <h2 className="text-xl font-bold text-gray-900 mb-4">¿Qué es RemesasVE?</h2>
          <p className="text-gray-600 text-sm leading-relaxed mb-6">
            RemesasVE es una plataforma de comparación de servicios de remesas diseñada específicamente para la comunidad venezolana en el exterior. Nuestro objetivo es simple: mostrarte de forma clara y honesta cuál es la mejor opción para enviar dinero a Venezuela en este momento.
          </p>
          <p className="text-gray-600 text-sm leading-relaxed mb-6">
            Comparamos servicios como Wise, Remitly, Western Union y WorldRemit, analizando tasas de cambio, comisiones, velocidad de envío y métodos de entrega. Toda la información se actualiza diariamente para que siempre tengas los datos más recientes.
          </p>

          <h2 className="text-xl font-bold text-gray-900 mb-4 mt-8">¿Por qué nació RemesasVE?</h2>
          <p className="text-gray-600 text-sm leading-relaxed mb-6">
            La comunidad venezolana en el exterior enfrenta una realidad única: la necesidad constante de apoyar económicamente a sus familias en Venezuela en un entorno de cambios económicos y cambiarios frecuentes. Muchas personas terminan pagando más de lo necesario simplemente por no tener acceso a información clara y actualizada.
          </p>
          <p className="text-gray-600 text-sm leading-relaxed mb-6">
            RemesasVE nació para llenar ese vacío. Queremos que cada venezolano que envíe dinero a casa lo haga con la mejor información disponible, sin complicaciones.
          </p>

          <h2 className="text-xl font-bold text-gray-900 mb-4 mt-8">¿Procesamos transferencias?</h2>
          <div className="bg-amber-50 border border-amber-200 rounded-xl p-5 mb-6">
            <p className="text-amber-800 text-sm leading-relaxed">
              <strong>No.</strong> RemesasVE es únicamente una plataforma de comparación. No procesamos transferencias, no manejamos fondos y no estamos afiliados directamente a ningún servicio de remesas. Cuando haces clic en un botón de envío, te redirigimos directamente al sitio del proveedor.
            </p>
          </div>

          <h2 className="text-xl font-bold text-gray-900 mb-4 mt-8">¿Cómo nos mantenemos?</h2>
          <p className="text-gray-600 text-sm leading-relaxed mb-6">
            RemesasVE puede recibir una comisión cuando un usuario hace clic en nuestros enlaces y completa una transacción con alguno de los servicios comparados. Esto no afecta la imparcialidad de nuestras comparaciones ni tiene ningún costo adicional para ti.
          </p>

          <h2 className="text-xl font-bold text-gray-900 mb-4 mt-8">Contáctanos</h2>
          <p className="text-gray-600 text-sm leading-relaxed mb-3">
            ¿Tienes preguntas, sugerencias o quieres colaborar con nosotros? Escríbenos:
          </p>
          <a
            href="mailto:info@remesasve.com"
            className="inline-flex items-center gap-2 text-green-600 hover:text-green-700 font-semibold text-sm"
          >
            <i className="ri-mail-line" />
            info@remesasve.com
          </a>
        </div>
      </div>
    </div>
  );
}
